
const TechFrigateLogo = () => (
  <div className="flex items-center space-x-1 ml-2 mb-2">
    <svg viewBox="0 0 40 40" className="h-5 w-5 shrink-0" aria-hidden="true"><rect width="40" height="40" rx="11" fill="#10b991" /><path d="M17 10h6v7h7v6h-7v7h-6v-7h-7v-6h7z" fill="#fff" /></svg>
      <h1 className="text-xs font-semibold text-[#4f9989]">Powered by Health Frigate</h1>
    </div>
);

export default TechFrigateLogo;
